<app-master-data-table [data]="this.masterCommonService.countriesList" [columns]="countryColumns" title="Countries List"
  addButtonLabel="Country" (add)="openAddUpdateCountryDialog('add')"
  (update)="openAddUpdateCountryDialog('update', $event)" (delete)="deleteCountry($event)">
</app-master-data-table>